import React, { useRef, useState } from "react";
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface Props {
  data: any;
  sectionTitle: string;
  sectionBgColor: string;
}

const EduFairParticipatingUniversity: React.FC<Props> = ({ data, sectionTitle, sectionBgColor }) => {
  const sliderRef = useRef<Slider>(null);
  const [selectedCountry, setSelectedCountry] = useState<any>(data[0])
  const settings = {
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    rows: 5,
    slidesPerRow: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          rows: 5,
          slidesPerRow: 2,

        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          infinite: true,
          arrows: false,
          rows: 4,
          slidesPerRow: 1,
          dotsClass: styles.sliderDots,
          dots: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: true,
          rows: 4,
          slidesPerRow: 1,
          dotsClass: styles.sliderDots,
          dots: true,
        }
      }
    ]
  };
  return (
    <div id="part-univer" className={styles.partUni} style={{ backgroundColor: sectionBgColor || '#DBD9FC' }}>
      <Container>
        <Row>
          <div className={styles.heading}>
            <h2>{sectionTitle}</h2>
          </div>
        </Row>
        <div className={styles.clickTabsCountry}>
          <Row>
            {
              data?.length > 0 &&
              data.map((country: any) => {
                return (
                  <Col lg={3} xl={3} md={4} sm={6} xs={6}>
                    <div className={`${styles.countryFlag} ${country.id === selectedCountry.id ? styles.activeClass : ''}`} onClick={() => setSelectedCountry(country)}>
                      <div className={styles.countryBox}>
                        <span className={styles.flag}> <CustomImage src={country?.flagUrl} width={55} height={30} className={styles.flaImg} alt="usaflag.svg" /></span>
                        <span className={styles.flagsapn}><p>{country?.countryName}</p></span>
                      </div>
                    </div>
                  </Col>
                )
              })
            }
          </Row>
        </div>
        <div id="show-univer-logo" className={styles.ClickshowUniLogo}>
          <Slider {...settings} className={styles.slider} ref={sliderRef} key={selectedCountry?.id}>
            {
              selectedCountry?.universities?.length > 0
                ? selectedCountry?.universities.map((university: any) => {
                  return (
                    <div className={styles.unilogoslider}>
                      <div className={styles.uniLogodiv}>
                        <div className={styles.uniImg}>
                          <CustomImage src={university?.imageUrl} width={58} height={53} className={styles.UniFlagImg} alt="UniversityofKansasKansas.png" />
                        </div>
                        <div className={styles.uniName}>
                          <p>{university?.title}</p>
                        </div>
                      </div>
                    </div>
                  )
                })
                : 'No Universities'
            }
          </Slider>
          <div className={styles.arrowsClass}>
            <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickPrev()}>
              <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
            </div>
            <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
              <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
            </div>
          </div>
        </div>
      </Container >
    </div >
  )
}
export default EduFairParticipatingUniversity;